<template>
	<div class="form">
		<div v-for="(bin, index) in formBins"
			v-if="bin > 0"
			:key="index"
			:style="{ width: binWidth(bin, formTotal) }">
			<img :src="formImage(index + 1)">
			<label>
				{{ binLabel(bin, formTotal) }}
			</label>
			<span class="count">
				{{ bin }}
			</span>
		</div>
	</div>
</template>
<script>
import ExcretionAnalysis from '.'

export default {
	name: 'patient-excretion-card-form-analysis',
	extends: ExcretionAnalysis
}
</script>

<style lang="scss" scoped>

.form {
	padding-left: 60px;
	padding-right: 30px;

	> div {
		position: relative;
		height: 20px;
		margin-bottom: 10px;
		background: #c0c0c0;

		img, label, .count {
			position: absolute;
		}
		img {
			height: 24px;
			max-width: 30px;
			left: -35px;
			top: -3px;
		}
		label {
			color: #3f3f3f;
			left: 10px;
			top: 5px;
			font-size: 12px;
			font-weight: 700;
			letter-spacing: 1px;
		}
		.count {
			color: #9f9f9f;
			font-size: 16px;
			font-weight: 700;
			line-height: 20px;
			right: 0;
			width: 55px;
			margin-right: -60px;
			text-align: left;
		}
	}
}
</style>
